import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useScrollAnimation } from '../../hooks/useScrollAnimation'
import { SUBSCRIPTION_PLANS } from '../../lib/utils/subscriptionPlans'

const PricingSection: React.FC = () => {
  const navigate = useNavigate()
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.1 })

  return (
    <section id="pricing" className="py-20 bg-gray-50">
      <div
        ref={ref}
        className="container mx-auto px-6"
        style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0)' : 'translateY(50px)',
          transition: 'opacity 0.8s ease-out, transform 0.8s ease-out',
        }}>
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Simple, Transparent Pricing
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Choose the plan that fits your needs. All plans are billed yearly.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {SUBSCRIPTION_PLANS.map((plan, index) => (
            <div
              key={index}
              className={`bg-white rounded-xl shadow-lg p-8 relative ${
                plan.name === 'pro' ? 'ring-4 ring-[#2C2B69] transform scale-105' : ''
              }`}>
              {plan.name === 'pro' && (
                <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                  <span className="bg-[#2C2B69] text-white px-4 py-1 rounded-full text-sm font-semibold">
                    Most Popular
                  </span>
                </div>
              )}

              <div className="text-center mb-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                  {plan.name.at(0)?.toUpperCase() + plan.name.slice(1)}
                </h3>
                <p className="text-gray-600 text-sm mb-4">{plan.perfectFor}</p>
                <div className="flex items-baseline justify-center">
                  <span className="text-5xl font-bold text-gray-900">
                    {plan.price.split('/').at(0)}
                  </span>
                </div>
                <span className="text-gray-600">per year</span>
              </div>

              <ul className="space-y-4 mb-8">
                {plan.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-start">
                    <svg
                      className="w-6 h-6 text-[#2C2B69] mr-3 flex-shrink-0"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>

              <button
                onClick={() => navigate('/auth/signup')}
                className={`w-full py-3 px-6 rounded-lg font-semibold transition ${
                  plan.name === 'pro'
                    ? 'bg-[#2C2B69] text-white hover:bg-[#2C2B69]/80'
                    : 'bg-gray-100 text-gray-900 hover:bg-gray-200'
                }`}>
                Select This Plan
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default PricingSection
